<template>
    <div>
        <div class="title">
            <img src="@/assets/screen-pic11.png" alt="" class="backIcon" @click="toBack()" v-if="showBackFn()">
            <div>
                爱心超市智能下单机
            </div>

        </div>
        <router-view style="padding-top:160px" />
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {

        }
    },
    watch: {
        // 路由若是发生变化，会再次执行该方法
        '$route': 'showBackFn'
    },
    mounted() {

    },
    methods: {
        showBackFn() {
            return this.$route.name == 'goods' || this.$route.name == 'contributionDetail';
        },
        toBack() {
            this.$router.back(-1)
        }
    }
}
</script>

<style>
@font-face {
    font-family: "YouSheBiaoTiHei-2";
    src: url("font/YouSheBiaoTiHei-2.ttf") format("truetype");
}
.title {
    width: 100%;
    height: 160px;
    background: linear-gradient(134deg, #ffaf2b 0%, #f68d23 100%);
    font-size: 46px;
    line-height: 160px;
    padding-left: 54px;
    text-shadow: 0px 2px 4px #ff8706;
    font-family: "YouSheBiaoTiHei-2";
    color: #fff;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
}
.backIcon {
    width: 50px;
    height: 50px;
    margin-right: 10px;
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue